<template>
    <div>
        <vue-echart v-if="ecConfig" :white-mode="whiteMode" :config="ecConfig" :height="height"></vue-echart>
    </div>
</template>

<script>
import VueEchart from "@/components/VueEchart";

export default {
    props: {
        whiteMode: {type: Boolean, default: false},
        height: {type: Number, default: 300},
        config:{type: String, default: null},
    },
    components: {VueEchart},
    computed: {
        ecConfig(){
            return this.config&&this.config!=="" ? JSON.parse(this.config) :  null
        }
    },
    name: 'CustomEcWidget',
    data: function () {
        return {
        }
    },
}

</script>

<style scoped>

</style>
